import React, { useState } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { Button } from 'telstra-ui/components/button/Button';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import Modal from 'telstra-ui/components/modal/Modal';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import { prepareDropDownOptionsArry } from '../../amp-homepage.actions';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import ServiceFilters from '../service-filters/service-filters';
import './plan-details-table.css';

const PlanDetailsTable = (props) => {
  const {
    authorableContent,
    authorableContent: {
      formFields: {
        planSearchFields,
        recommendedServicePlans,
      },
      username,
      bulkActionText,
      bulkCancelText,
      bulkUpgradeText,
      itemSelectedText,
      currentPlanName,
      amPlanName,
      dataAllowanceConsume,
      data,
      gbText,
      filterTopLink,
      filterEditTopLink,
      cost,
      bulkUpgradeTextPrefix,
      bulkPlanUpgradeTextSuffix,
      paginationNumbers,
      paginationBaseNumber,
      filterClearAll,
      deviceType,
    },
    serviceNumbersPlanDetails,
    onChangeCheckBox,
    planServiceCheckAll,
    planServiceCheckboxVal,
    searchPlanSelectedOption,
    onSearchPlanFieldChange,
    movePlanDetails,
    pageChangeHandler,
    currentPage,
    bulkPlanModalOpen,
    isBulkPlanModalOpen,
    bulkPlanModalClose,
    bulkPlanDeviceValue,
    onBulkPlanChangeDropDown,
    onBulkPlanActionsApply,
    planSorting,
    planSortingClick,
    searchTextChange,
    searchText,
    currentPlanList,
    serviceNumbersWithFlag,
    onPlanAllChangeCheckBox,
  } = props;

  const [filterOpen, setFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterClearAllStatus, setFilterClearAllStatus] = useState(false);
  const [totalRecords, setTotalRecords] = useState(serviceNumbersPlanDetails.length);
  const [planSearchText, setPlanSearchText] = useState('');
  const [filterSearchedResults, setFilterSearchedResults] = useState([]);

  const [pageSize, setPageSize] = useState(parseInt(paginationBaseNumber, 10));
  const numberOfPages = filterApplied ? Math.ceil(totalRecords / pageSize) : Math.ceil(serviceNumbersPlanDetails.length / pageSize);
  const pageSizeOptions = paginationNumbers.split(',');

  // const planDropDownOptionsVal = recommendedServicePlans.options.filter(plan => !plan.value.includes('Wireless'));
  const planDropDownOptionsVal = recommendedServicePlans.options;

  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber, 'plan-details-table-section-amp');
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setTimeout(() => {
      const lastTableRow = document.getElementById('plan-details-table').lastElementChild.lastElementChild;
      lastTableRow.scrollIntoView();
    }, 200);
  };

  const totalPlanSelected = () => {
    if (filterApplied && planSearchText.length > 0) {
      return Object.entries(planServiceCheckboxVal)
        .filter(itm => filterSearchedResults.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    } else if (filterApplied) {
      return Object.entries(planServiceCheckboxVal)
        .filter(itm => filteredData.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    }
    return Object.entries(planServiceCheckboxVal)
      .filter(itm => serviceNumbersPlanDetails.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
        && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
  };

  const bulkApplyOnSelectedItems = () => {
    if (planServiceCheckAll) {
      if (filterApplied && planSearchText.length > 0) {
        const selectedNumbers = filterSearchedResults.filter(serviceItem => planServiceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onBulkPlanActionsApply(selectedNumbers);
      } else if (filterApplied) {
        const selectedNumbers = filteredData.filter(serviceItem => planServiceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onBulkPlanActionsApply(selectedNumbers);
      } else {
        const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => planServiceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        onBulkPlanActionsApply(selectedNumbers);
      }
    } else {
      const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => planServiceCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      onBulkPlanActionsApply(selectedNumbers);
    }
  };

  const getNewDeviceValue = (deviceKey) => {
    const option = recommendedServicePlans.options.find(item => item.key === deviceKey);
    const defaultOption = recommendedServicePlans.options.find(item => item.key === 'removePlan');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const getPlanDisabledStatus = (deviceKey) => {
    const option = recommendedServicePlans.options.find(item => item.key === deviceKey);
    if (option) {
      return false;
    }
    return true;
  };

  const getSearchSelectionValue = (searchKey) => {
    const option = planSearchFields.options.find(item => item.key === searchKey);
    const defaultOption = planSearchFields.options.find(item => item.key === 'nosearch');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const searchFieldsDropDownOptions = prepareDropDownOptionsArry(planSearchFields.options);
  const planNameDropDownOptions = prepareDropDownOptionsArry(planDropDownOptionsVal);

  const movePlan = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    const number = event.target.parentElement.parentElement.id.split('-')[0];
    movePlanDetails(selectedValue, number);
  };

  const getDataRows = () => {
    if (filterApplied && planSearchText.length > 0) {
      return filterSearchedResults;
    } else if (filterApplied) {
      return filteredData;
    }
    return serviceNumbersPlanDetails;
  };

  const onSearchText = () => {
    if (filterApplied) {
      return planSearchText;
    }
    return searchText;
  };

  const onSearchTextChange = (event) => {
    const filterSearchText = event.target.value;
    setPlanSearchText(filterSearchText);
    if (filterApplied) {
      let filterResults = [];
      if (searchPlanSelectedOption === 'number') {
        filterResults = filteredData.filter(numbers => numbers.serviceNumber.includes(filterSearchText));
      } else if (searchPlanSelectedOption === 'username') {
        filterResults = filteredData.filter(numbers => numbers.userName.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchPlanSelectedOption === 'currentplan') {
        filterResults = filteredData.filter(numbers => numbers.currentPlan.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchPlanSelectedOption === 'nosearch') {
        filterResults = filteredData;
        setPlanSearchText('');
      }
      onPageChange(0);
      setTotalRecords(filterResults.length);
      setFilterSearchedResults(filterResults);
    } else {
      searchTextChange(event);
    }
  };

  const onSearchDropDownChange = (event) => {
    if (filterApplied) {
      setPlanSearchText('');
      setFilterSearchedResults(filteredData);
      setTotalRecords(filteredData.length);
      onSearchPlanFieldChange(event);
    } else {
      onSearchPlanFieldChange(event);
    }
  };

  const applyFilterOnFullData = (filterObj) => {
    let filterResults = serviceNumbersPlanDetails;

    if (filterObj.fiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction === '1');
    }
    if (filterObj.nonFiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction !== '1');
    }
    if (filterObj.voiceCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === false);
    }
    if (filterObj.dataCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === true);
    }
    let currentPlanResults = [];
    if (filterObj.currentPlanSelected.length > 0) {
      filterObj.currentPlanSelected.forEach((plan) => {
        const planResults = filterResults.filter(itm => itm.currentPlan.toLowerCase() === plan.toLowerCase());
        currentPlanResults = [...currentPlanResults, ...planResults];
      });
      filterResults = [...currentPlanResults];
    }

    let suggestPlanResults = [];
    if (filterObj.recommendPlanSelectId.length > 0) {
      filterObj.recommendPlanSelectId.forEach((plan) => {
        const planResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].planName.toLowerCase() === plan.toLowerCase());
        suggestPlanResults = [...suggestPlanResults, ...planResults];
      });
      filterResults = [...suggestPlanResults];
    }

    onPageChange(0);
    setPlanSearchText('');
    setFilterApplied(true);
    setFilteredData(filterResults);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
    setTotalRecords(filterResults.length);
  };

  const clearFilterApplied = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(true);
  };

  const cancelFilter = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
  };

  const onChangeAllCheckBox = (event) => {
    if (filterApplied) {
      onPlanAllChangeCheckBox(event, filteredData);
    } else {
      onPlanAllChangeCheckBox(event, serviceNumbersPlanDetails);
    }
  };

  const getTotalRecords = () => (filterApplied ? totalRecords : serviceNumbersPlanDetails.length);

  const rowData = dataTable => dataTable.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(service => (
    <tr key={`${service.serviceNumber}`}>
      <td className="sticky-col">
        {serviceNumbersWithFlag[service.serviceNumber].dataOnly === true &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-authentication-hotspot" className="mobile-pill-icon" />
          </div>
        }
        {serviceNumbersWithFlag[service.serviceNumber].dataOnly === false &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-mobiles-mobile" className="mobile-pill-icon" />
          </div>
        }
      </td>
      <td className="sticky-col1">
        {service.suggestedPlanName !== 'unaddressableServices' &&
          <div className="table-item-text ri-flex-service-width inline">
            <Checkbox
              id={`${service.serviceNumber}-planService`}
              onChange={onChangeCheckBox}
              checked={planServiceCheckboxVal[service.serviceNumber]}
              label={formatPhoneNumber(service.serviceNumber)}
            />
            {service.fiveGInteraction === '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width inline">
                <SvgIcon name="icon-bill-5g" className="mobile-pill-icon" />
              </div>
            }
            {service.fiveGInteraction !== '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width-not-5g inline">
                <SvgIcon name="icon-system-circle-filled" className="mobile-pill-icon" />
              </div>
            }
          </div>
        }
      </td>
      <td><div className="table-item-text">{service.userName}</div></td>
      <td><div className="table-item-text">{service.currentPlan}</div></td>
      <td><div className="table-item-text">{service.currentPlanCost}</div></td>
      <td>
        <div className="table-item-text">{service.currentData}{gbText} <br />
          <span className="trade-in-note">({service.dataUsage}{gbText})</span>
        </div>
      </td>
      <td>
        {service.suggestedPlanName !== 'unaddressableServices' &&
          <div className="new-device-selection table-item-text">
            <Dropdown
              value={getNewDeviceValue(serviceNumbersWithFlag[service.serviceNumber].planName)}
              dropdownId={`${service.serviceNumber}-plan-dropdown`}
              options={planNameDropDownOptions}
              onOptionClick={movePlan}
            />
          </div>
        }
        {service.suggestedPlanName === 'unaddressableServices' &&
          <div className="new-device-selection table-item-text">
            {service.currentPlan}
          </div>
        }
      </td>
      <td><div className="table-item-text">{service.deviceType}</div></td>
    </tr>
  ));

  return (
    <div id="plan-details-table-section-amp" className="plan-details-table-section-amp">
      <div className="plan-offer-table">
        <div className="row table-nav">
          <div className="col-2 table-action items">
            {totalPlanSelected()} {itemSelectedText}
          </div>
          <div className="col-2 table-action">
            <Button
              variant="primary"
              onClick={bulkPlanModalOpen}
              size="medium"
            >
              {bulkActionText}
            </Button>
          </div>
          <div className="col-3 search-field-option">
            {(filterOpen === false) &&
              <Dropdown
                value={getSearchSelectionValue(searchPlanSelectedOption)}
                dropdownId="search-plan-field-option"
                options={searchFieldsDropDownOptions}
                onOptionClick={onSearchDropDownChange}
                className="search-field-option-container"
              />
            }
          </div>
          <div className="col-2 search-field-option-text">
            {(filterOpen === false) &&
              <TextInput
                name="plan-search-text"
                onChange={onSearchTextChange}
                placeholder={planSearchFields.placeholder}
                value={onSearchText()}
              />
            }
          </div>
          <div className="col-1 table-action">
            {filterApplied &&
              <Button
                variant="primary"
                onClick={() => clearFilterApplied()}
                size="medium"
              >
                {filterClearAll}
              </Button>
            }
          </div>
          <div className="col-1 offset-1 table-action filter-button">
            <SvgIcon name="icon-product-filter" className="icon-filter" />
            <Button
              variant="secondary"
              size="medium"
              state="app"
              className="filter-button"
              onClick={() => setFilterOpen(!filterOpen)}
            > {filterApplied ? filterEditTopLink : filterTopLink}</Button>
          </div>
          <div className="col-12">
            <ServiceFilters
              authorableContent={authorableContent}
              applyFilter={applyFilterOnFullData}
              cancelFilter={cancelFilter}
              filterOpen={filterOpen}
              filterApplied={filterApplied}
              currentPlanList={currentPlanList}
              filterClearAll={filterClearAllStatus}
            />
          </div>
        </div>
        <div id="plan-details-table-section" className="plan-details-table-section row">
          <div className="sticky-wrapper col-12">
            <div className="sticky-scroller">
              <table className="sticky-table" id="plan-details-table">
                <thead>
                  <tr>
                    <th className="sticky-col">&nbsp;</th>
                    <th className="sticky-col1">
                      <div className="table-title">
                        <Checkbox
                          id="all-planService"
                          onChange={e => onChangeAllCheckBox(e)}
                          checked={getTotalRecords() > 0 && getTotalRecords() === totalPlanSelected()}
                          label="Service Number"
                        />
                        {planSorting.numberSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="number-sort-asc"
                            onClick={() => planSortingClick('number', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {planSorting.numberSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="number-sort-desc"
                            onClick={() => planSortingClick('number', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {username}
                        {planSorting.userSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="user-sort-asc"
                            onClick={() => planSortingClick('userName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {planSorting.userSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="user-sort-desc"
                            onClick={() => planSortingClick('userName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {currentPlanName}
                        {planSorting.currentPlanNameSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="current-plan-name-sort-asc"
                            onClick={() => planSortingClick('currentPlanName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {planSorting.currentPlanNameSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="current-plan-name-sort-desc"
                            onClick={() => planSortingClick('currentPlanName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-small-width">
                        {cost}
                        {planSorting.currentPlanCostSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="current-plan-cost-sort-asc"
                            onClick={() => planSortingClick('currentPlanCost', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {planSorting.currentPlanCostSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="current-plan-cost-sort-desc"
                            onClick={() => planSortingClick('currentPlanCost', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-large-width">
                        {data} <br /> {dataAllowanceConsume}
                        {planSorting.dataUsageSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="data-usage-sort-asc"
                            onClick={() => planSortingClick('dataUsage', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {planSorting.dataUsageSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="data-usage-sort-desc"
                            onClick={() => planSortingClick('dataUsage', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th><div className="table-title ri-flex-eelarge-width">{amPlanName}</div></th>
                    <th><div className="table-title ri-flex-elarge-width">{deviceType}</div></th>
                  </tr>
                </thead>
                <tbody>
                  {rowData(getDataRows())}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={filterApplied ? totalRecords : serviceNumbersPlanDetails.length}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <Modal
        isOpen={isBulkPlanModalOpen}
        onShowModal={bulkPlanModalClose}
        size="large"
        className="bulk-tradein-modal"
      >
        <Modal.Header>{bulkActionText}</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              {bulkUpgradeTextPrefix} {totalPlanSelected()} {bulkPlanUpgradeTextSuffix}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Dropdown
                value={getNewDeviceValue(bulkPlanDeviceValue)}
                dropdownId="bulk-plan-dropdown"
                options={planNameDropDownOptions}
                onOptionClick={onBulkPlanChangeDropDown}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="xSmall"
            onClick={bulkPlanModalClose}
          >{bulkCancelText}</Button>
          <Button
            variant="super"
            size="medium"
            state="app"
            onClick={() => bulkApplyOnSelectedItems()}
            disabled={getPlanDisabledStatus(bulkPlanDeviceValue)}
          >{bulkUpgradeText}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PlanDetailsTable;
